var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.516.734l6.75 6.75c.14.141.234.329.234.516 0 .14-.094.375-.234.516l-6.75 6.75c-.282.28-.797.28-1.078 0-.282-.282-.282-.75 0-1.079l5.484-5.437H1.25C.828 8.75.5 8.375.5 8s.328-.75.75-.75h20.672l-5.485-5.438c-.28-.28-.28-.796 0-1.078.282-.28.797-.28 1.079 0z",
    fill: "#868E96"
  })));
}
export default SvgLongArrow;